module.exports = __webpack_public_path__ + "img/qrcode.7ad64de1.png";